import { render, staticRenderFns } from "./PointIndicator.vue?vue&type=template&id=33cecabb"
import script from "./PointIndicator.vue?vue&type=script&lang=ts"
export * from "./PointIndicator.vue?vue&type=script&lang=ts"
import style0 from "./PointIndicator.vue?vue&type=style&index=0&id=33cecabb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports